import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
// Register user
export const registerUser = async (userData) => {
  return await axios.post(`${API_URL}/users/register`, userData);
};
export const dashboardUser = async (userData) => {
  return await axios.post(`${API_URL}/users/dashboard`, userData);
};
// Login user
export const loginUser = async (userData) => {
  return await axios.post(`${API_URL}/users/login`, userData);
};

export const receiveTransactions = async (userData) => {
  return await axios.post(`${API_URL}/users/receive`, userData);
};

// Send transactions (with pagination)
export const sendTransactions = async (userData) => {
  return await axios.post(`${API_URL}/users/send`, userData);
};

// settelemnts (with pagination)
export const settelements = async (userData) => {
  return await axios.post(`${API_URL}/users/settelements`, userData);
};


// Developer Section - fetch details
export const getDeveloperDetails = async (userData) => {
  return await axios.post(`${API_URL}/users/developer_section`, userData);
};

// Developer Section - update details
export const updateDeveloperDetails = async (userData) => {
  return await axios.post(`${API_URL}/users/developer_section/update`, userData);
};

export const createPaymentLink = async (payload) => {
  try {
    const res = await axios.post(`${API_URL}/payin/create_payment_link`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return res.data;
  } catch (error) {
    console.error("❌ API Error:", error.response?.data || error.message);
    throw error.response?.data || { message: error.message };
  }
};

export async function checkPaymentStatus(order_id) {
  try {
    const res = await axios.get(`${API_URL}/payin/status/${order_id}`);
    return res.data.data;
  } catch (err) {
    console.error("Error checking status:", err);
    return { status: "ERROR", message: "Unable to check status" };
  }
}
export async function getPaymentDetails(order_id) {
  try {
    const res = await axios.get(`${API_URL}/payin/${order_id}`);
    return res.data;
  } catch (err) {
    console.error("Error fetching payment details:", err);
    return { success: false, message: "Failed to load payment details" };
  }
}
export async function cancelPayment(order_id) {
  try {
    const res = await axios.post(`${API_URL}/payin/${order_id}/status`, {
      status: "cancelled",
    });
    return res.data;
  } catch (err) {
    console.error("Error cancelling payment:", err);
    return { success: false, message: "Failed to cancel payment" };
  }
}